/* BBDP 2026-10-16 — Capture e-mail / SMS dans le tiroir panier (test A/B 50/50)
 *
 * Groupe A = témoin (rien n'est affiché), groupe B = bloc affiché.
 * Seules les visiteuses que Klaviyo ne connaît pas encore entrent dans le test.
 * Mesure :
 *   - attribut de panier « _bbdp_capture_panier » = A ou B (visible sur les commandes Shopify) ;
 *   - événements dataLayer « bbdp_capture_panier » (vue / envoi) avec le groupe.
 * À l'envoi :
 *   1. identification du navigateur dans Klaviyo (_learnq identify) ;
 *   2. abonnement e-mail (et SMS si numéro) à la liste [SHOPIFY AND FB SUBSCRIBERS], source « Tiroir panier » ;
 *   3. événement Klaviyo « Panier sauvegardé BBP » avec le contenu du panier (déclenche le flow 03C).
 */
(function () {
  'use strict';

  var COMPANY_ID = 'HZ3B32';
  var LIST_ID = 'VHbAdG';
  var REVISION = '2025-10-15';
  var COOKIE = 'bbdp_cc_groupe';
  var KEY_DONE = 'bbdp_cc_done';       // e-mail donné : ne plus jamais afficher
  var KEY_CLOSED = 'bbdp_cc_closed';   // fermé par la cliente : masqué 7 jours
  var KEY_ATTR = 'bbdp_cc_attr';       // attribut de panier déjà posé pour ce panier

  function store(get, k, v) {
    try {
      if (get) return window.localStorage.getItem(k);
      window.localStorage.setItem(k, v);
    } catch (e) { return null; }
  }

  function readCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }

  function group() {
    var g = readCookie(COOKIE);
    if (g !== 'A' && g !== 'B') {
      g = Math.random() < 0.5 ? 'A' : 'B';
      document.cookie = COOKIE + '=' + g + '; path=/; max-age=' + 60 * 60 * 24 * 90 + '; SameSite=Lax';
    }
    return g;
  }

  function cookieIdentified() {
    var raw = readCookie('__kla_id');
    if (!raw) return false;
    try {
      var data = JSON.parse(atob(raw));
      return !!(data.$exchange_id || data.$email || data.$phone_number || data.$kx);
    } catch (e) { return false; }
  }

  function isIdentified() {
    var k = window.klaviyo;
    if (k && typeof k.isIdentified === 'function') {
      return Promise.resolve(k.isIdentified()).then(function (v) { return !!v || cookieIdentified(); }, cookieIdentified);
    }
    return Promise.resolve(cookieIdentified());
  }

  function dl(action, g) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'bbdp_capture_panier', bbdp_cc_action: action, bbdp_cc_groupe: g });
  }

  var lastTag = 0;
  function tagCart(g) {
    // Une fois par panier : on pose le groupe en attribut pour le retrouver sur la commande.
    if (Date.now() - lastTag < 5000) return;
    lastTag = Date.now();
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.token) return;
        if (store(true, KEY_ATTR) === cart.token + g) return;
        if (cart.attributes && cart.attributes._bbdp_capture_panier === g) {
          store(false, KEY_ATTR, cart.token + g);
          return;
        }
        return fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { _bbdp_capture_panier: g } })
        }).then(function () { store(false, KEY_ATTR, cart.token + g); });
      })
      .catch(function () {});
  }

  function closedRecently() {
    var t = parseInt(store(true, KEY_CLOSED) || '0', 10);
    return t && Date.now() - t < 7 * 24 * 3600 * 1000;
  }

  function normPhone(v) {
    var p = (v || '').replace(/[\s.\-()]/g, '');
    if (!p) return '';
    if (/^0[67]\d{8}$/.test(p)) return '+33' + p.slice(1);
    if (/^0033[67]\d{8}$/.test(p)) return '+' + p.slice(2);
    if (/^\+\d{8,15}$/.test(p)) return p;
    return null;
  }

  function klaviyoPost(path, payload) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + COMPANY_ID, {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: REVISION },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok && r.status !== 202) throw new Error('klaviyo ' + path + ' ' + r.status);
    });
  }

  function submit(box, g) {
    var emailEl = box.querySelector('[data-bbdp-cc-email]');
    var phoneEl = box.querySelector('[data-bbdp-cc-phone]');
    var errEl = box.querySelector('[data-bbdp-cc-error]');
    var btn = box.querySelector('[data-bbdp-cc-submit]');
    var email = (emailEl.value || '').trim();
    var phone = normPhone(phoneEl.value);

    errEl.hidden = true;
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
      errEl.textContent = 'Cette adresse e-mail ne semble pas valide.';
      errEl.hidden = false;
      emailEl.focus();
      return;
    }
    if (phone === null) {
      errEl.textContent = 'Ce numéro de mobile ne semble pas valide (ex. 06 12 34 56 78).';
      errEl.hidden = false;
      phoneEl.focus();
      return;
    }
    btn.disabled = true;

    var profileAttrs = { email: email, properties: { bbdp_capture_panier: 'Tiroir panier' } };
    if (phone) profileAttrs.phone_number = phone;

    // 1. Identification du navigateur (les prochains événements du site seront rattachés)
    window._learnq = window._learnq || [];
    var ident = { $email: email };
    if (phone) ident.$phone_number = phone;
    window._learnq.push(['identify', ident]);

    // 2. Abonnement
    var subs = { email: { marketing: { consent: 'SUBSCRIBED' } } };
    if (phone) subs.sms = { marketing: { consent: 'SUBSCRIBED' } };
    var subscribe = klaviyoPost('subscriptions', {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Tiroir panier',
          profile: { data: { type: 'profile', attributes: { email: email, phone_number: phone || undefined, subscriptions: subs } } }
        },
        relationships: { list: { data: { type: 'list', id: LIST_ID } } }
      }
    });

    // 3. Événement avec le contenu du panier
    var event = fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart.items || []).map(function (i) {
          return {
            'Product Name': i.product_title,
            'Variant Name': i.variant_title,
            ProductID: i.product_id,
            VariantID: i.variant_id,
            Quantity: i.quantity,
            Price: i.final_price / 100,
            ImageURL: i.image ? (i.image.indexOf('//') === 0 ? 'https:' + i.image : i.image) : '',
            URL: 'https://www.bonsbaisers.paris' + (i.url || '')
          };
        });
        var first = items[0] || {};
        var props = {
          'Product Name': first['Product Name'],
          ImageURL: first.ImageURL,
          URL: first.URL,
          Price: first.Price,
          Items: items,
          ItemNames: items.map(function (i) { return i['Product Name']; }),
          ItemCount: cart.item_count,
          CartURL: 'https://www.bonsbaisers.paris/cart',
          Groupe: g,
          $value: cart.total_price / 100
        };
        return klaviyoPost('events', {
          data: {
            type: 'event',
            attributes: {
              properties: props,
              value: cart.total_price / 100,
              metric: { data: { type: 'metric', attributes: { name: 'Panier sauvegardé BBP' } } },
              profile: { data: { type: 'profile', attributes: profileAttrs } }
            }
          }
        });
      });

    Promise.all([subscribe, event])
      .then(function () {
        store(false, KEY_DONE, '1');
        dl('envoi', g);
        box.querySelector('[data-bbdp-cc-step="form"]').hidden = true;
        box.querySelector('[data-bbdp-cc-step="done"]').hidden = false;
      })
      .catch(function () {
        btn.disabled = false;
        errEl.textContent = "Petit souci de notre côté, réessayez dans un instant.";
        errEl.hidden = false;
      });
  }

  function bind(box, g) {
    if (box.__bbdpBound) return;
    box.__bbdpBound = true;

    box.addEventListener('keydown', function (e) {
      // Le bloc est dans le formulaire du panier : Entrée ne doit pas lancer le paiement.
      if (e.key === 'Enter') { e.preventDefault(); submit(box, g); }
    });
    box.addEventListener('input', function (e) {
      if (e.target.hasAttribute('data-bbdp-cc-phone')) {
        box.querySelector('[data-bbdp-cc-sms-legal]').hidden = !e.target.value.trim();
      }
    });
    box.addEventListener('click', function (e) {
      if (e.target.closest('[data-bbdp-cc-submit]')) { e.preventDefault(); submit(box, g); }
      if (e.target.closest('[data-bbdp-cc-close]')) {
        e.preventDefault();
        store(false, KEY_CLOSED, String(Date.now()));
        box.hidden = true;
        dl('fermeture', g);
      }
    });
  }

  var exposed = false;

  // Place le bloc sous les articles du tiroir (le tiroir est re-rendu à chaque ajout).
  function mount() {
    var tpl = document.getElementById('bbdp-cc-template');
    var wrapper = document.querySelector('cart-drawer .drawer__cart-items-wrapper');
    if (!tpl || !wrapper) return null; // cliente connectée ou panier vide
    var next = wrapper.nextElementSibling;
    if (next && next.hasAttribute('data-bbdp-cc')) return next;
    var box = tpl.content.firstElementChild.cloneNode(true);
    box.hidden = true;
    wrapper.parentNode.insertBefore(box, wrapper.nextSibling);
    return box;
  }

  function run() {
    if (store(true, KEY_DONE)) return;
    var box = mount();
    if (!box) return;

    isIdentified().then(function (known) {
      if (known) return; // hors test : Klaviyo peut déjà relancer cette visiteuse
      var g = group();
      tagCart(g);
      // « eligible » est envoyé pour les deux groupes : c'est la base de comparaison du test.
      if (!exposed) { exposed = true; dl('eligible', g); if (g === 'B' && !closedRecently()) dl('vue', g); }
      if (g !== 'B' || closedRecently()) return;
      if (box.hidden) box.hidden = false;
      bind(box, g);
    });
  }

  function start() {
    run();
    // Le tiroir est re-rendu à chaque ajout : on relance l'affichage à chaque changement.
    var drawer = document.querySelector('cart-drawer');
    if (drawer && window.MutationObserver) {
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        setTimeout(function () { pending = false; run(); }, 50);
      }).observe(drawer, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
